import { apiClient } from '@/httpConfig/config/axios.js';

/**
 * The collector's per-shop supplier preview (supplier-preview P2-A, brief
 * 2026-10-20-supplier-preview). Plain JSON on the one `apiClient`, like the
 * meeting request. Errors propagate — the caller decides the toast.
 *
 *  - POST   /collector/supplier-preview           {organizationId} → {shop, expiresAt}
 *           (403 not a collector, 422 NOT_A_SHOP; a second enter switches shops)
 *  - DELETE /collector/supplier-preview           → 204 always
 *  - POST   /collector/supplier-preview/interest  {phone?} → {ok: true}
 *           (409 PREVIEW_NOT_ACTIVE, 422 a bad phone)
 *           offline form {organizationId, id, at, phone?} → {ok: true, status:
 *           applied|already_applied} (403, 422 NOT_A_SHOP / a bad phone) —
 *           brief 2026-10-20-supplier-preview-offline; sent by collector/previewLeads.js
 */

/**
 * @param {{ organizationId: string|number }} params
 * @returns {Promise<{ shop: {id, name, phone}, expiresAt: string }>}
 */
export async function enterPreview({ organizationId }) {
  const response = await apiClient.post('/collector/supplier-preview', {
    organizationId: Number(organizationId),
  });
  return response?.data ?? {};
}

export async function exitPreview() {
  await apiClient.delete('/collector/supplier-preview');
}

/**
 * @param {{ phone?: string|null, organizationId?: string|number, id?: string, at?: string }} [params] —
 *   the phone is omitted when empty; `organizationId` + `id` + `at` make the offline form.
 */
export async function noteInterest({ phone, organizationId, id, at } = {}) {
  const body = organizationId == null ? {} : { organizationId: Number(organizationId), id, at };
  if (phone) body.phone = phone;
  const response = await apiClient.post('/collector/supplier-preview/interest', body);
  return response?.data ?? {};
}
